import React, { useState,useEffect } from "react";
import { API_URL,RESPONSE_SUCCESS } from './../../GlobalConstents.js';
import { useNavigate } from "react-router-dom";
import HeaderLayout from "./../../Layout/Header";
import API from './../../Api';
import { toast } from 'react-toastify';
import Loader from "../../Elements/Loader";
import TestBlock from "./TestBlock.jsx";


const TestSeriesList = () => {

    const navigate = useNavigate();

    const [testSeriesListOngoing, setTestSeriesListOngoing] = useState([]); 
    const [testSeriesListAttempted, setTestSeriesListAttempted] = useState([]); 
    const [isLoading, setIsLoading] = useState(false);
    const [videoURL, setVideoURL] = useState('');

    useEffect(
        () => {
        document.body.classList.add('theme-red');
        document.body.classList.remove('login-page');
        document.body.classList.remove('overlay-open');

        LoadTestSeriesListOngoing()
        
    },[true]); 

    const LoadTestSeriesListOngoing = async () => {

        let objValue =  {"method_name":"onGoingTestSeries","page":1}

        setIsLoading(true);
        await API.post(API_URL,objValue).then(function (response) {
           
            
            if (response.status === RESPONSE_SUCCESS) {
                
                if (response.data.status === "success") {
                    
                    setTestSeriesListOngoing(response.data.examList);
                    setIsLoading(false);
                    
                } else {
                    toast.error(response.data.message);
                }
            }

        }).catch(function (error) {
           // ForceLogoutUser(error);
        });

    }

    
    return (
        <>
        <HeaderLayout />
        
        <section className="content ">
            <div className="container-fluid">
                <div className="block-header">
                    <h2>Test Series</h2>
                </div>
                <div className="row clearfix">

                    {isLoading ? (
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 text-center">
                            <Loader />
                        </div>
                    ) : (
                        
                        testSeriesListOngoing.length > 0 ? (
                            testSeriesListOngoing.map((item, index) => ( 
    
                                <TestBlock item={item} />
                            ))
                        ) : (
                            <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 text-center">
                                Record Not Found
                            </div>
                        )    
                        
                    )}
                </div>
            </div>
        </section>
        </>
    );
   
}
    
export default TestSeriesList;